import React, { memo, useMemo } from 'react';
import Dropdown from '@components/dropdown';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { generateProjectUrlSearch as getSearch } from '@utils/common';

import {
  INTEGRATION_APPROACH_KEY,
  SEPARATION_APPROACH_KEY,
  OPERATING_MODEL_KEY,
  INSIGHT_KEY,
  VALUE_DRIVER_KEY,
  DEAL_RATIONALE_KEY,
  MATURITY_ASSESSMENT_KEY,
  getInsightsDropdownList,
} from '@model/insights';

export const OPERATING_MODEL = OPERATING_MODEL_KEY;
export const INSIGHTS = INSIGHT_KEY;

export const VALUE_DRIVER = VALUE_DRIVER_KEY;
export const INTEGRATION_APPROACH = INTEGRATION_APPROACH_KEY;
export const SEPARATION_APPROACH = SEPARATION_APPROACH_KEY;
export const DEAL_RATIONALE = DEAL_RATIONALE_KEY;
export const MATURITY_ASSESSMENT = MATURITY_ASSESSMENT_KEY;

const InsightsDropdown = ({ section }) => {
  const projectId = useSelector((state) => state.common.currentId);
  const {
    // permission,
    singleCompanyInstance,
    // sectionsPermission,
    // internalSectionsPermission,
    accessibleModules,
    insightsOriginPermissions,
  } = useSelector((state) => ({
    // permission: state.projects.sectionsPermission.analysisPermission,
    singleCompanyInstance: state.projects.saveData.singleCompanyInstance,
    // sectionsPermission: state.projects.sectionsPermission,
    // internalSectionsPermission: state.projects.internalSectionsPermission,
    accessibleModules: state.projects?.originAccessibleModules,
    insightsOriginPermissions: state.projects?.customizedModules?.find?.(
      (i) => i.value === 'insight',
    )?.originPermissions,
  }));

  // const role = useSelector((state) => state.login.userInfo.role);
  const projectType = useSelector(
    (state) => state.common.projectCompanyInfo.instanceType,
  );
  const history = useHistory();

  const dropdownList = getInsightsDropdownList({
    permissionCodes: accessibleModules?.moduleList,
    isDivestiture: singleCompanyInstance === 'Divestiture',
    projectType,
    originPermissions: insightsOriginPermissions,
  });

  const redirect = (e) => {
    history.push(`/insights/${e}?${getSearch(projectId)}`);
  };

  // const genTitle = (k) => {
  //   return k === MATURITY_ASSESSMENT_KEY && projectType === 'Divestiture'
  //     ? 'Separation Readiness Assessment'
  //     : k === MATURITY_ASSESSMENT_KEY && projectType === 'Integration'
  //     ? 'Integration Readiness Assessment'
  //     : k === GUIDING_PRINCIPLES_KEY && projectType === 'Customize'
  //     ? 'Guiding Principles'
  //     : INSIGHT_SEGMENTS_INSIGHT_DROPDOWNS[k];
  // };

  const title = useMemo(
    () => dropdownList?.find((i) => i.id === section)?.title,
    [section, dropdownList],
  );

  return (
    <Dropdown
      title={title}
      list={dropdownList}
      sendData={redirect}
      permission={section}
    />
  );
};

export default memo(InsightsDropdown);
